const messages: Record<string, string> = {
	'onboardingStart.headline': 'Hello! Check your information so we can begin.',
	'onboardingStart.name': 'Name',
	'onboardingStart.plateNumber': 'Plate number:',
	'onboardingStart.year': 'Year',
	'onboardingStart.timeout': 'This link will be active until ',
	'onboardingStart.support': 'Need help? Call Solvd!',

	'onboarding.headline': 'Ready to start your digital inspection?',
	'onboarding.paragraph': 'Before starting the process, please consider the following:',
	'onboarding.documents':
		"Have the <b>keys</b> and the <b>vehicle's registration card</b> available.",
	'onboarding.camera': 'Photos can only be taken using your <b>smartphone camera</b>.',
	'onboarding.internet':
		'Be in a place with <b>good lighting</b> and a <b>strong internet connection</b>.',
	'onboarding.vehicle':
		'Ensure the vehicle is <b>clean</b>, <b>accessible from all angles</b>, and that all <b>windows are closed</b>.',

	poweredBy: 'Powered by <ce>ControlExpert</ce> a <solvd>Solvd</solvd> group company',

	'onboarding.terms.before': 'Before beginning, please confirm the following:',
	'onboarding.terms.url': 'I agree with <tclink>Terms and conditions</tclink>.',

	'approval.description':
		'Check if the bank account number given below is correct. If so, confirm the estimate and the above amount will be transferred to your account.',
	'approval.lacquerCosts': 'Paintwork',
	'button.changeImage': 'Change the photo',
	'button.anotherImage': 'Take another photo',
	'button.deleteImage': 'Delete the photo',
	'button.acceptImage': 'Accept the photo',
	'button.acceptMileage': 'Correct',
	'photo.deleteConfirmation.title': 'Are you sure you want to delete this photo?',
	'photo.deleteConfirmation.description':
		'If you delete this photo, you will need to take a new one.',
	'photo.deleteConfirmation.confirm': 'Delete photo',
	'photo.deleteConfirmation.cancel': 'Cancel',
	'validationContainer.correct': 'Correct',
	'button.prev': 'Back',
	'button.next': 'Continue',
	'button.photo.take': 'Take photo',
	'damageImages.title': 'Damage Photos',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration certificate',
	'damageImages.additionalImages': 'Additional photos of the damages',
	'damageImages.description': 'You can add up to {imageCount, number} photos',
	'damageImages.booleanRadioGroupLabel': 'Does your vehicle have any damage?',
	'damageImages.booleanRadioGroupLabelLeft': 'No',
	'damageImages.booleanRadioGroupLabelRight': 'Yes',
	'damageImages.optionalDamageImages': 'Optionally, add more photos showing the damages.',
	'feedback.button.send': 'Send the opinion',
	'feedback.description': 'We hope that you are satisfied with our service.',
	'feedback.rating': 'How do you rate the claim settlement with EasyClaim?',
	'vehicleImages.details.first': 'The front of the vehicle',
	'vehicleImages.details.rearright':
		'Take a photo of the vehicle with the whole rear and right side. The license plate should be readable.',
	'vehicleImages.overviewPhotos': 'Vehicle overview photos',
	'vehicleImagesExampleModal.headline.first': 'Vehicle overview photos – an example',
	'waitForAudit.description.damageFound':
		'The next step is up to us. We will inform you about the result of the inspection by phone or e-mail.',
	'waitForAudit.description.damageNotFound':
		'The next step is up to us. We will inform you about the result of the inspection by phone or e-mail.',

	'vehicleFrontLeftPerspectiveImage.title': 'Photo of the vehicle front left',
	'vehicleFrontLeftPerspectiveImage.description':
		'Take photo of the front left diagonal, ensuring the entire car is in the frame and the license plate is visible.',

	'vehicleFrontRightPerspectiveImage.title': 'Photo of the vehicle front right',
	'vehicleFrontRightPerspectiveImage.description':
		'Take photo of the front right diagonal, ensuring the entire car is in the frame and the license plate is visible.',

	'vehicleRearLeftPerspectiveImage.title': 'Photo of the vehicle rear left',
	'vehicleRearLeftPerspectiveImage.description':
		'Take photo of the rear left diagonal, ensuring the entire car is in the frame and the license plate is visible.',

	'vehicleRearRightPerspectiveImage.title': 'Photo of the vehicle rear right',
	'vehicleRearRightPerspectiveImage.description':
		'Take photo of the rear right diagonal, ensuring the entire car is in the frame and the license plate is visible.',

	'dashboardMileage.title': 'Photo of the odometer',
	'vehicleMileage.description':
		'Capture a photo of the odometer, ensuring that the digital reading is in sharp focus and completely legible.',

	'windshieldImage.description':
		'Capture an photo of the windshield, ensuring the entire glass area and its details are clearly visible.',

	'vinPicture.description':
		'Take a close-up photo of the Vehicle Identification Number (VIN) area, ensuring all characters are legible.',

	'overallDashboardImage.description':
		'Capture an overall photo of the dashboard, making sure all controls and features are fully in view.',

	'review.title': 'Summary of your digital inspection',
	'review.paragraph.first':
		'Before finishing, please verify that all information is correct.<br/><br/>After clicking "Complete", we will confirm your photos and information.',
	'review.button.next': 'Complete',
	'thanks.headline.first': 'Photos received successfully!',
	'thanks.paragraph.first': 'Your request is being reviewed by our technical team.',
	'timeout.headline.first': 'The requested case was not found.',
	'timeout.paragraph.first': 'Your case has expired or the link you accessed is incorrect.',

	'review.stepDescription.group.perspectiveImages': 'Vehicle overview photos',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Photo of the vehicle front left',
	'review.stepDescription.vehicleFrontRightPerspective': 'Photo of the vehicle front right',
	'review.stepDescription.vehicleRearLeftPerspective': 'Photo of the vehicle rear left',
	'review.stepDescription.vehicleRearRightPerspective': 'Photo of the vehicle rear right',
	'review.stepDescription.group.additionalImages': 'Additional pictures',
	'review.stepDescription.questions': 'Vehicle information',

	'missingPhoto.title': 'Missing photo',
	'missingPhoto.description':
		'It seems that a photo is missing. Please add the missing photo to proceed.',

	'blockedByDevice.headline': 'Use a smartphone',
	'blockedByDevice.paragraph.first':
		'This link can only be used on smartphones. Scan the following QR code with your smartphone to begin the process.',
	'blockedByDevice.paragraph.second':
		'A quick tip: when opening the link, you should be near the vehicle and have your documents ready.',

	'photoUploading.title': 'Uploading',
	'photoAnalyzing.title': 'Analyzing',
	'photoLoading.title': 'Loading',
	'landscapeModeDetected.title': 'Auto-rotate enabled',
	'landscapeModeDetected.text':
		'Please disable auto-rotate on your device for a better camera experience.',

	'button.hint': "Where's my VIN number located?",
	'hint.vin': 'XXXXXXXXXXXXXXXXX',
	'hint.vin.title': 'Possible VIN locations',
	'hint.vin.description': 'It can typically be found in those 4 locations:',
	'hint.vin.location1': "On the dashboard, visible through the windshield on the driver's side.",
	'hint.vin.location2': "On the driver's side door frame, near the latch.",
	'hint.vin.location3': 'In the engine bay, often on a metal plate.',
	'hint.vin.location4': 'Front end of frame (older vehicles).',

	'thankYou.message': 'Your request is being reviewed by our technical team.',
	'feedback.title': 'We would appreciate your feedback.',
	'feedback.message':
		'On a scale of 0 to 5, how would you rate your experience having your digital inspection done with us?',
	'feedback.helpImprove': 'Help us improve (optional):',
	'feedback.error.maxLength': 'Feedback cannot exceed more than {maxLength} characters.',

	'invalidFile.size.title': 'Incorrect photo size',
	'invalidFile.size.description': 'The photo size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',

	'dashboardMileage.placeholder.updated': 'insert mileage (km)',
	'questions.DoesTheVehicleHaveCNG': 'Doses the vehicle have CNG?',
	'questions.ArmoredVehicle': 'Armored vehicle?',
	'questions.DoesTheVehicleHaveModifiedSuspension': 'Does the vehicle have modified suspension?',
	'questions.WasTheChassisNumberRemarked': 'Was the chassis number remarked?',
	'questions.yes': 'Yes',
	'questions.no': 'No',
	'questions.paragraph':
		'If the vehicle has any modifications that you wish to document, please answer the following questions:',
	'questions.title': 'Vehicle information',

	'fullscreen.prompt': 'Fullscreen mode is available for a better experience',
	'fullscreen.prompt.accept': 'Open in fullscreen',
	'fullscreen.prompt.dismiss': 'Continue',
	'camera.darkWarning':
		'The environment is potentially too dark — please improve the lighting for better photo quality.',
};

export default messages;
